// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1k-0";